import {
  Button,
  Flex,
  HStack,
  Text,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react'
import { MoonIcon, SunIcon } from '@chakra-ui/icons'
import { Link } from 'react-router-dom'

export default function Nav() {
  const { colorMode, toggleColorMode } = useColorMode()
  const linkColor = useColorModeValue('gray.800', 'green.300')
  const navBg = useColorModeValue(
    'rgba(232, 220, 202, 0.95)',
    'rgba(20, 20, 23, 0.92)'
  )
  const navBorder = useColorModeValue('#d1c7b8', '#3a3a40')

  return (
    <Flex
      as="nav"
      position="fixed"
      top="0"
      left="0"
      right="0"
      zIndex="100"
      px="4"
      py="3"
      alignItems="center"
      backdropFilter="blur(12px)"
      bg={navBg}
      borderBottom="1px solid"
      borderColor={navBorder}
      boxShadow="sm"
    >
      <HStack
        spacing="8"
        position="absolute"
        left="50%"
        transform="translateX(-50%)"
      >
        <Link to="/">
          <Text
            fontSize="xl"
            fontWeight="bold"
            fontFamily="mono"
            color={linkColor}
            _hover={{ opacity: 0.8 }}
          >
            ~/
          </Text>
        </Link>
        <Link to="/uses">
          <Text
            fontSize="md"
            fontFamily="mono"
            color={linkColor}
            _hover={{ opacity: 0.8 }}
          >
            uses
          </Text>
        </Link>
      </HStack>
      <Button
        size="md"
        onClick={toggleColorMode}
        variant="ghost"
        ml="auto"
        aria-label="Toggle color mode"
      >
        {colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
      </Button>
    </Flex>
  )
}
